import { useAppAction, useAppSelector } from '../hooks';
import { SpacesManagementState } from './spacesManagementTypes';
import { OFFICES_MANAGEMENT_NAMESPACE } from './spacesManagementReducer';
import {
  spacesManagementFetchSpacesMyCompanyThunk,
  spacesManagementFetchSpacesThunk,
} from './spacesManagementActions';

export function useSpacesManagementSelector<
  T extends (state: SpacesManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[OFFICES_MANAGEMENT_NAMESPACE])
  );
}

export const useSpacesManagementSpaces = () =>
  useSpacesManagementSelector((state) => {
    return state.spaces;
  });

export const useSpacesManagementGetSpaceById = (id: number) =>
  useSpacesManagementSelector((state) => {
    return state.spaces.find((space) => space.id === id);
  });

export const useSpacesManagementCompanySpaces = () =>
  useSpacesManagementSelector((state) => {
    return state.companySpaces;
  });

export const useFetchSpacesManagementSpaces = () =>
  useAppAction(spacesManagementFetchSpacesThunk);

export const useFetchSpacesManagementSpacesByCompany = () =>
  useAppAction(spacesManagementFetchSpacesMyCompanyThunk);
